var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","default-first-option":"","remote":"","placeholder":"选择平台","size":_vm.size,"clearable":""},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }